import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-module-permission',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './module-permission.component.html',
  styleUrl: './module-permission.component.css'
})
export class ModulePermissionComponent implements OnInit {

  @Input() module: any;
  @Output() onToggle = new EventEmitter<any>();
  ngOnInit(): void {
    

  }
  toggleModule() {
    this.onToggle.emit(this.module);
  }
}
